"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryServiceClientImpl = exports.MsgServiceClientImpl = exports.protobufPackage = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const query_1 = require("./query");
const tx_1 = require("./tx");
exports.protobufPackage = "axelar.nexus.v1beta1";
class MsgServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || "axelar.nexus.v1beta1.MsgService";
        this.rpc = rpc;
        this.RegisterChainMaintainer = this.RegisterChainMaintainer.bind(this);
        this.DeregisterChainMaintainer = this.DeregisterChainMaintainer.bind(this);
        this.ActivateChain = this.ActivateChain.bind(this);
        this.DeactivateChain = this.DeactivateChain.bind(this);
        this.RegisterAssetFee = this.RegisterAssetFee.bind(this);
        this.SetTransferRateLimit = this.SetTransferRateLimit.bind(this);
    }
    RegisterChainMaintainer(request) {
        const data = tx_1.RegisterChainMaintainerRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterChainMaintainer", data);
        return promise.then((data) => tx_1.RegisterChainMaintainerResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeregisterChainMaintainer(request) {
        const data = tx_1.DeregisterChainMaintainerRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeregisterChainMaintainer", data);
        return promise.then((data) => tx_1.DeregisterChainMaintainerResponse.decode(new minimal_1.default.Reader(data)));
    }
    ActivateChain(request) {
        const data = tx_1.ActivateChainRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ActivateChain", data);
        return promise.then((data) => tx_1.ActivateChainResponse.decode(new minimal_1.default.Reader(data)));
    }
    DeactivateChain(request) {
        const data = tx_1.DeactivateChainRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "DeactivateChain", data);
        return promise.then((data) => tx_1.DeactivateChainResponse.decode(new minimal_1.default.Reader(data)));
    }
    RegisterAssetFee(request) {
        const data = tx_1.RegisterAssetFeeRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RegisterAssetFee", data);
        return promise.then((data) => tx_1.RegisterAssetFeeResponse.decode(new minimal_1.default.Reader(data)));
    }
    SetTransferRateLimit(request) {
        const data = tx_1.SetTransferRateLimitRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "SetTransferRateLimit", data);
        return promise.then((data) => tx_1.SetTransferRateLimitResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.MsgServiceClientImpl = MsgServiceClientImpl;
class QueryServiceClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || "axelar.nexus.v1beta1.QueryService";
        this.rpc = rpc;
        this.LatestDepositAddress = this.LatestDepositAddress.bind(this);
        this.TransfersForChain = this.TransfersForChain.bind(this);
        this.FeeInfo = this.FeeInfo.bind(this);
        this.TransferFee = this.TransferFee.bind(this);
        this.Chains = this.Chains.bind(this);
        this.Assets = this.Assets.bind(this);
        this.ChainState = this.ChainState.bind(this);
        this.ChainsByAsset = this.ChainsByAsset.bind(this);
        this.RecipientAddress = this.RecipientAddress.bind(this);
        this.ChainMaintainers = this.ChainMaintainers.bind(this);
        this.TransferRateLimit = this.TransferRateLimit.bind(this);
        this.Message = this.Message.bind(this);
    }
    LatestDepositAddress(request) {
        const data = query_1.LatestDepositAddressRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "LatestDepositAddress", data);
        return promise.then((data) => query_1.LatestDepositAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    TransfersForChain(request) {
        const data = query_1.TransfersForChainRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "TransfersForChain", data);
        return promise.then((data) => query_1.TransfersForChainResponse.decode(new minimal_1.default.Reader(data)));
    }
    FeeInfo(request) {
        const data = query_1.FeeInfoRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "FeeInfo", data);
        return promise.then((data) => query_1.FeeInfoResponse.decode(new minimal_1.default.Reader(data)));
    }
    TransferFee(request) {
        const data = query_1.TransferFeeRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "TransferFee", data);
        return promise.then((data) => query_1.TransferFeeResponse.decode(new minimal_1.default.Reader(data)));
    }
    Chains(request) {
        const data = query_1.ChainsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Chains", data);
        return promise.then((data) => query_1.ChainsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Assets(request) {
        const data = query_1.AssetsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Assets", data);
        return promise.then((data) => query_1.AssetsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChainState(request) {
        const data = query_1.ChainStateRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ChainState", data);
        return promise.then((data) => query_1.ChainStateResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChainsByAsset(request) {
        const data = query_1.ChainsByAssetRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ChainsByAsset", data);
        return promise.then((data) => query_1.ChainsByAssetResponse.decode(new minimal_1.default.Reader(data)));
    }
    RecipientAddress(request) {
        const data = query_1.RecipientAddressRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "RecipientAddress", data);
        return promise.then((data) => query_1.RecipientAddressResponse.decode(new minimal_1.default.Reader(data)));
    }
    ChainMaintainers(request) {
        const data = query_1.ChainMaintainersRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ChainMaintainers", data);
        return promise.then((data) => query_1.ChainMaintainersResponse.decode(new minimal_1.default.Reader(data)));
    }
    TransferRateLimit(request) {
        const data = query_1.TransferRateLimitRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "TransferRateLimit", data);
        return promise.then((data) => query_1.TransferRateLimitResponse.decode(new minimal_1.default.Reader(data)));
    }
    Message(request) {
        const data = query_1.MessageRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "Message", data);
        return promise.then((data) => query_1.MessageResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryServiceClientImpl = QueryServiceClientImpl;
